export { default as PlaybackControls } from './component';
